import React from "react";
import { MuiTelInput } from "mui-tel-input";
import PropTypes from "prop-types";

const MDTelInput = (props) => {
  return (
    <MuiTelInput
      fullWidth
      name={props?.name}
      sx={{ marginTop: "15px" }}
      label={
        <span>
          {props?.label || "Mobile No"}{" "}
          {props?.required && <span style={{ color: "red" }}> *</span>}{" "}
        </span>
      }
      value={props?.value}
      onChange={(val, data) => props?.handleChange(data)}
      onBlur={props?.onBlur}
      variant={props?.variant}
      onlyCountries={["IN"]}
    />
  );
};

MDTelInput.propTypes = {
  handleChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  variant: PropTypes.string,
  value: PropTypes.number,
};

export default MDTelInput;
